import React from "react";

import user from "assets/userFloat.svg";

const UserFloatingButton = ({ setIsViewKpi, bottompossition, icon }) => {
  return (
    <div>
      {" "}
      <img
        src={icon || user}
        alt="Floating User Icon"
        style={{
          position: "fixed",
          bottom: bottompossition || "80px",
          right: "20px",
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          zIndex: 1000,
          cursor: "pointer",
        }}
        onClick={() => setIsViewKpi(true)}
      />
    </div>
  );
};

export default UserFloatingButton;
